var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.reasonsForRefusal
    ? _c(
        "jade-alert",
        {
          attrs: {
            showIcon: "",
            variant: _vm.reasonsForRefusal.variant,
            icon: _vm.reasonsForRefusal.icon,
            link: _vm.reasonsForRefusal.link,
          },
          on: { handleLinkClick: _vm.eventCaller },
        },
        [
          _vm._v(" " + _vm._s(_vm.reasonsForRefusal.message) + " "),
          _vm.reasonsForRefusalParams
            ? _c("b", [_vm._v(" " + _vm._s(_vm.reasonsForRefusalParams) + " ")])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }